export default __webpack_public_path__ + "static/media/f0549a56bc3ce7898e94dfd0a7e369a5.svg";